/**
 * BREDA — Cart refresh event handler + Shopify section re-init
 * Scroll reveals are handled by breda-reveal.js.
 */
(function () {
  'use strict';

  // ── Cart item-count refresh after add-to-cart ──────────────────
  // Fired by breda-lineup.liquid add-to-cart buttons
  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Update any data-cart-count elements (Horizon renders these)
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        // Trigger Horizon cart bubble refresh if component is available
        var bubble = document.querySelector('cart-bubble');
        if (bubble && typeof bubble.updateCount === 'function') {
          bubble.updateCount(cart.item_count);
        }
      })
      .catch(function () {});
  });
})();
